import React from "react";
import {message} from "antd";
import MaterialService from "./MaterialService";
import {getModel, setModel, DICT_KEY} from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";

const MODEL_KEY = DICT_KEY.BASE_MATERIAL
const storageModel = getModel(MODEL_KEY);
const materialModel = {
    state: !!storageModel ? storageModel : {
        searchParam: {},
        materialSortList: [],
        materialList: [],
        pageInfo: {},
        selectedTypeNode:null,
        selectedMaterial: null,
        selectedRowKeys: []
    },
    reducers: {
        setSearchParam(state, payload) {
            state.searchParam = {...payload};
            setModel(MODEL_KEY, {...state});
        },
        setMaterialSortList(state, payload) {
            state.materialSortList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setMaterialList(state, payload) {
            state.materialList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPageInfo(state, payload) {
            state.pageInfo = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedMaterial(state, payload) {
            state.selectedMaterial = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedRowKeys(state, payload) {
            state.selectedRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedTypeNode(state, payload){
            state.selectedTypeNode = payload;
            setModel(MODEL_KEY, {...state});
        }
    },
    effects: () => ({
        async loadMaterialSortList({showMsg = true, duration = 5}) {
            const funName = "加载物料类型";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await MaterialService.findTypeTree();
                this.setMaterialSortList(retData);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadMaterialList({showMsg = true, duration = 5, data}) {
            const funName = "加载物料";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            data.pageSize=data.pageSize||15
            data.pageNum=data.pageNum||1

            try {
                let retData = await MaterialService.findPage(data);
                let {list, ...page} = retData
                list.forEach((el) => el.key = el.id);
                this.setMaterialList(list);
                this.setPageInfo(page);
                if (showMsg) message.success(sucMsg, duration)
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }
        },

        async insert({showMsg = true, duration = 5, data}) {
            const funName = "新增物料";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            try {
                let ret = await MaterialService.insert(data);
                // console.log(ret)
                this.loadMaterialList({showMsg:false,data:{}})
                if (ret) message.success(sucMsg, duration)
                return ret
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }
        },
        async update({showMsg = true, duration = 5, data}) {
            const funName = "更新物料";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            try {
                let ret = await MaterialService.update(data);
               
                if (ret){
                    message.success(sucMsg, duration)
                    this.loadMaterialList({showMsg:false,data:{}})
                    return ret
                }
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }
        },
        async enableOrDisable({showMsg = true, duration = 5, data},{material}) {
            const funName = "更新物料状态";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // console.log(data)
            try {
                let ret = await MaterialService.enableOrDisable(data);
                const {materialList} = material
                const mapMaterialList = materialList.map(el=>{
                    if(el.id==data.id){
                        return {...el,materialStatus:data.materialStatus}
                    }
                    return el
                })
                // console.log(mapMaterialList)
                this.setMaterialList(mapMaterialList);
                if (showMsg) message.success(sucMsg, duration)
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }
        },        
    })
}

export default materialModel;